import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AnnulmentsPage } from './annulments';

@NgModule({
  declarations: [
    AnnulmentsPage,
  ],
  imports: [
    IonicPageModule.forChild(AnnulmentsPage),
  ],
})
export class AnnulmentsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/annulments/annulments.module.ts